import Menu from '@/global/components/MenuV2'
import { cn } from '@/lib/utils'
import { Button, ButtonProps, MenuItemProps } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface IPropsMenuButton extends ButtonProps {
    children?: React.ReactNode
    startIcon: JSX.Element
    label?: string
    position?:
        | 'left'
        | 'right'
        | 'center'
        | 'top-left'
        | 'top-right'
        | 'top-center'
}

export const GridMenuButton = React.forwardRef<
    HTMLButtonElement,
    IPropsMenuButton
>(({ children, startIcon, label, ...rest }, ref) => {
    return (
        <Menu.Root id={rest.id} position={rest.position}>
            <Menu.Trigger>
                <GridButton ref={ref} {...{ startIcon, label, ...rest }} />
            </Menu.Trigger>
            <Menu.List>{children}</Menu.List>
        </Menu.Root>
    )
})

GridMenuButton.displayName = 'GridMenuButton'

interface IGridButtonProps extends ButtonProps {
    href?: string
    onlyView?: number | number[]
    startIcon: JSX.Element
    label?: string
}

export function GridButton({
    label,
    href,
    onClick,
    ...props
}: IGridButtonProps) {
    const navigate = useNavigate()

    const Icon = props.startIcon && !label ? props.startIcon : null
    const startIcon = props.startIcon && label ? props.startIcon : null

    return (
        <Button
            {...props}
            startIcon={startIcon}
            variant="text"
            className={cn(
                'flex flex-row items-center',
                'justify-start md:justify-center md:w-fit w-full',
                'h-9 text-xs',
                'hover:bg-primary/15',
                props.className,
            )}
            onClick={e => {
                if (href) {
                    e.preventDefault()
                    onClick?.(e)
                    navigate(href)
                } else if (onClick) {
                    onClick(e)
                }
            }}
        >
            {Icon}
            {!!label && <span>{label}</span>}
            {props.children}
        </Button>
    )
}

export function GridMenuItem({
    label,
    startIcon = <React.Fragment />,
    ...props
}: MenuItemProps & {
    href?: string
    startIcon?: JSX.Element
    label: string
}) {
    return (
        <Menu.Item {...props}>
            {React.cloneElement(startIcon, {
                sx: { mr: 1 },
            })}
            <span>{label}</span>
            {props.children}
        </Menu.Item>
    )
}
